import { Text } from '@/shared/ui/primitives';
import type { FC, ReactNode } from 'react';

import type { TestProps } from '@/types';
import styles from './ActionSection.module.css';

interface ActionSectionProps extends TestProps {
  title?: string;
  inactiveActions?: ReactNode;
  activeActions?: ReactNode;
  isActive?: boolean;
  inactiveSubActions?: ReactNode;
  children: ReactNode;
}

export const ActionSection: FC<ActionSectionProps> = ({
  title,
  inactiveActions,
  activeActions,
  isActive = false,
  inactiveSubActions,
  children,
  testId,
}) => {
  return (
    <div className={styles.sectionWrapper}>
      {!isActive ? (
        <div className={styles.headerRow}>
          <Text variant="title" as="h1" weight="bold" className={styles.title} data-testid={testId}>
            {title}
          </Text>
          {inactiveActions && (
            <div className={styles.actionsContainer} role="group" aria-label="Page actions">
              {inactiveActions}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.searchBarWrapper}>{activeActions}</div>
      )}

      {!isActive && inactiveSubActions}

      {children}
    </div>
  );
};
